<app-template>

    <div class="fad-desktop">
        <div class="register">
            <div class="formulario">
                <app-sms></app-sms>
            </div>
            <div class="ptitle">
                <div class="imagen"></div>
            </div>
        </div>
    </div>

</app-template>
